import styles from './styles.module.scss';

import { Link } from '@mui/material';
import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { createAddress, createAddressHRef } from '../utils/create-address';

import { InlineData } from './InlineData';

type IAddressCardProps = {
  street: string;
  postalCode: string;
  city: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

export const AddressCard: FC<IAddressCardProps> = ({
  street,
  postalCode,
  city,
  onClick,
}) => {
  const { t } = useTranslation();

  const address = createAddress({
    street,
    postalCode,
    city,
  });

  return (
    <InlineData
      onClick={onClick}
      label={t('FILE_CONTACTS.ADDRESS')}
      content={
        address ? (
          <Link
            target="_blank"
            rel="noreferrer"
            underline="none"
            variant="body2"
            className={styles['link']}
            href={
              street && postalCode && city ? createAddressHRef(address) : '#'
            }
          >
            {address}
          </Link>
        ) : (
          '-'
        )
      }
    />
  );
};
